import React, { useState, useEffect } from 'react';
import { TextField } from "@material-ui/core";
import NumberFormat from 'react-number-format';

export default function MoreInfo(props) {
	const phoneNumberFormat = (event) => {
		let brackets = event.target.value.replace(/[-()+]/g, '');
		let spaces = brackets.split(" ").join("");
		props.values.customer_info.customer_phone_no = spaces
	}

	const handleKeyDown = e => {
		if (e.key === " ") {
		  e.preventDefault();
		}
	  };

	const handleChange = (e) => {
		props.values.customer_info.customer_email = e.target.value.replace(/\s/g, "");
	}
	const handleFirstName = (e) => {
		props.values.customer_info.customer_first_name = e.target.value
	}
	const handleLastName = (e) => {
		props.values.customer_info.customer_last_name = e.target.value
	}
	useEffect(() => {
		if (props.reset === true) {
			props.values.customer_info.customer_email = ''
		}
	})

	return (
		<div className="form-question">
			<div className="form-content" >
				<h4 className="form-content-heading m-0">
					Can you give us a little more information in case we have follow up questions?
				</h4>
				<div className="pt-2 form-content-field">
					<div className="py-2">
						<div className="w-res-50 py-2 d-sm-flex">
							<div className="col-12 col-sm-6 pl-sm-0 pr-sm-2 p-0">
								<div className="pb-2">
									<h6 className="m-0">First Name</h6>
								</div>
								<div>
									<TextField
										type="text"
										id="customer_first_name"
										variant="outlined"
										name="customer_info.customer_first_name"
										className="form-TextField"
										onChange={handleFirstName, props.handleChange}
										value={props.values.customer_info.customer_first_name.trimStart()}
									/>
								</div>
							</div>
							<div className="col-12 col-sm-6 pr-sm-0 pl-sm-2 p-0 pt-3 pt-sm-0">
								<div className="pb-2">
									<h6 className="m-0">Last Name</h6>
								</div>
								<div>
									<TextField
										type="text"
										id="customer_last_name"
										variant="outlined"
										name="customer_info.customer_last_name"
										className="form-TextField"
										onChange={handleLastName, props.handleChange}
										value={props.values.customer_info.customer_last_name.trimStart()}
									/>
								</div>
							</div>
						</div>
						<div className="w-res-50 py-2">
							<div className="pb-2">
								<h6 className="m-0">Email Address</h6>
							</div>
							<div>
								<TextField
									type="email"
									id="customer_email"
									variant="outlined"
									name="customer_info.customer_email"
									className="form-TextField"
									onKeyDown={handleKeyDown}
									onChange={handleChange, props.handleChange}
									value={props.values.customer_info.customer_email.trimStart()}
									disabled={props.emailOneDisable}
								/>
							</div>
						</div>
						<div className="w-res-50 py-2">
							<div className="pb-2">
								<h6 className="m-0">Phone Number</h6>
							</div>
							<div>
								<div className="d-flex align-items-center" id="emailId">
									<div className="px-2 border rounded" style={{height: '56px',padding: '17.5px 14px'}}>+1</div>
									<NumberFormat
									    id="phoneNumber"
										className="phonenumber-field"
										format=" (###) ###-####"
										onChange={(e)=>phoneNumberFormat(e)}
										onFocus={props.handleChange}
                                        name="customer_info.phone_no"
										//onInput={(e)=>phoneNumberFormat(e)}
										value={props.values.customer_info.customer_phone_no.trimStart()}
										allowEmptyFormatting />
								</div>
							</div>
						</div>
					</div>
					{ props.validateDisplay1 === true ? props.errors.customer_email ?
					 <div className="error-msg">{props.errors.customer_email}</div> : ''
					: ''}
				</div>
			</div>
		</div>
	)
}
